/**
 * Invoice providers for transfer recipients.
 *
 * @readonly
 * @enum {string}
 */
export const InvoiceProviders = Object.freeze({
  SION: 'SION',
  ONYX: 'ONYX',
  MANUAL: 'MANUAL',
});
